<template>
  <v-dialog v-model="dialogModel" max-width="400px">
    <v-card color="#2B2D33">
      <v-card-title class="text-white">导出PDF设置</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-radio-group v-model="exportMode" class="mt-0">
                <v-radio
                  :label="`导出全部图片 (${props.totalCount}张)`"
                  :value="false"
                  :disabled="!hasImages"
                ></v-radio>
                <v-radio
                  :label="`仅导出选中图片 (${props.selectedCount}张)`"
                  :value="true"
                  :disabled="!hasSelectedImages"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <v-radio-group v-model="orientation" class="mt-4">
                <div class="d-flex align-center">
                  <span class="text-subtitle-2 mr-4">页面方向：</span>
                  <v-radio
                    label="横向"
                    value="landscape"
                    class="mr-4"
                  />
                  <v-radio
                    label="纵向"
                    value="portrait"
                  />
                </div>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" variant="tonal" @click="handleCancel">取消</v-btn>
        <v-btn 
          color="primary" 
          variant="flat" 
          @click="handleConfirm"
          :disabled="!canExport"
        >
          确认导出
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'

const props = defineProps<{
  modelValue: boolean
  hasImages: boolean
  hasSelectedImages: boolean
  totalCount: number
  selectedCount: number
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'export', selectedOnly: boolean, orientation: 'portrait' | 'landscape'): void
}>()

const dialogModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

// 根据是否有选中图片设置默认导出模式
const exportMode = ref(false)
const orientation = ref<'portrait' | 'landscape'>('landscape')

// 在弹框打开时设置默认值
watch(() => props.modelValue, (newValue) => {
  if (newValue) {
    // 如果选中数量大于0且小于总数，默认选择"仅导出选中"
    // 如果选中数量等于0或等于总数，默认选择"导出全部"
    exportMode.value = props.selectedCount > 0 && props.selectedCount < props.totalCount
  }
})

const canExport = computed(() => {
  if (exportMode.value && !props.hasSelectedImages) return false
  if (!exportMode.value && !props.hasImages) return false
  return true
})

const handleCancel = () => {
  dialogModel.value = false
}

const handleConfirm = () => {
  console.log('ExportPDFDialog - handleConfirm', {
    exportMode: exportMode.value,
    orientation: orientation.value
  });
  emit('export', exportMode.value, orientation.value)
  dialogModel.value = false
}
</script>
